import type {
  PermissionAuditLogMeta,
  PermissionAuditLogQuery,
  PermissionAuditLogResult,
} from './types/permission-audit-log'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

let permissionAuditLogMetaPromise: Promise<PermissionAuditLogMeta> | undefined

export const permissionAuditLogApi = defineApi('operation', ({ prefix }) => {
  function getMeta() {
    if (!permissionAuditLogMetaPromise) {
      permissionAuditLogMetaPromise = requestClient
        .get<PermissionAuditLogMeta>(prefix('bizAudit/meta'))
        .catch((error: unknown) => {
          permissionAuditLogMetaPromise = undefined
          throw error
        })
    }

    return permissionAuditLogMetaPromise
  }

  function list({
    condition,
    orderBy,
    pageIndex,
    pageSize,
    sortBy,
  }: PermissionAuditLogQuery): Promise<PermissionAuditLogResult> {
    return requestClient.post<PermissionAuditLogResult>(
      prefix('bizAudit/query'),
      {
        condition,
        orderBy,
        pageIndex,
        pageSize,
        sortBy,
      },
    )
  }

  return {
    list,
    getMeta,
  }
})
